import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MaterMaccAccountData } from '../_models/matermacc/materMaccAccountData';
import { environment } from '../../../environments/environment';

@Injectable()
export class MaterMaccService {
  private telemetryServiceUrl = environment.telemetryServiceUrl;

  constructor(private http: HttpClient) {}

  getMaterMaccAccountData(): Observable<MaterMaccAccountData> {
    return this.http
      .get<any>(this.telemetryServiceUrl + 'api/provider/MATERMACC/account')
      .pipe(map((response) => response));
  }

  storeMaterMaccCredentials(materMaccAccountData: MaterMaccAccountData) {
    return this.http
      .post(this.telemetryServiceUrl + 'api/provider/MATERMACC/onboarding', materMaccAccountData)
      .pipe(map((response) => response));
  }

  disconnectMaterMaccAccount(): Observable<any> {
    return this.http
      .delete(this.telemetryServiceUrl + 'api/provider/MATERMACC/disconnect')
      .pipe(map((response) => console.log('disconnected')));
  }

  getMaterMaccAccountStatus(): Observable<any> {
    return this.http.get<any>(this.telemetryServiceUrl + 'api/provider/MATERMACC/is-connected');
  }
}
